import {
  DenominationEmployeeRegistration,
  DenominationReporting
} from "features/denominations";
import { HelpCenter, HelpLayout } from "features/help";
import { MemberRegistration } from "features/members";

export const commonRoutes = [
  {
    path: "/forms/:churchId/:formId",
    element: <MemberRegistration />
  },
  {
    path: "/forms/denomination-reporting/:denominationId/:formToken",
    element: <DenominationReporting />
  },
  {
    path: "/forms/denomination-employees/:denominationId/:formToken",
    element: <DenominationEmployeeRegistration />
  },
  {
    path: "/help-center",
    element: <HelpLayout />,
    children: [{ path: "", element: <HelpCenter /> }]
  }
];
